var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { format, isValid } from 'date-fns';
import { isFalsy } from '../../../utils/common';
export var GRADING_SCHEME = {
    CGPA: 'CGPA',
    PERCENTAGE: 'PERCENTAGE',
    ZERO_TO_FOUR: 'ZERO_TO_FOUR'
};
export var getModifiedGradeLabel = function (option) {
    switch (option === null || option === void 0 ? void 0 : option.value) {
        case 'CGPA':
            return __assign(__assign({}, option), { label: "".concat(option.label, " (scale out of 10)") });
        case 'PERCENTAGE':
            return __assign(__assign({}, option), { label: "".concat(option.label, " (scale out of 100)") });
        case 'ZERO_TO_FOUR':
            return __assign(__assign({}, option), { label: "".concat(option.label, " (scale out of 4)") });
        default:
            return option;
    }
};
export var getFilterOptions = function (options) {
    if (!options)
        return [];
    var validaOptions = options.filter(function (option) {
        return typeof (option === null || option === void 0 ? void 0 : option.title) !== 'undefined' &&
            typeof (option === null || option === void 0 ? void 0 : option.id) !== 'undefined' &&
            (option === null || option === void 0 ? void 0 : option.title) !== null &&
            (option === null || option === void 0 ? void 0 : option.id) !== null;
    });
    return validaOptions.map(function (option) { return (__assign(__assign({}, option), { defaultLabel: option.label, label: option === null || option === void 0 ? void 0 : option.title, value: option === null || option === void 0 ? void 0 : option.id })); }).sort(function (a, b) { return (b === null || b === void 0 ? void 0 : b.count) - (a === null || a === void 0 ? void 0 : a.count); });
};
export var getSortedUniversityFilters = function (form, options) {
    // sort order
    // 1. Selected values
    // 2. High offer institute
    // 3. rest options
    var _a, _b, _c;
    var fixedOptions = getFilterOptions(options);
    var collegeIds = ((_c = (_b = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.collegeIds) !== null && _c !== void 0 ? _c : []).map(function (op) { return op === null || op === void 0 ? void 0 : op.value; });
    fixedOptions.sort(function (o1, o2) {
        var priorityOrder = {
            PREFERRED_INSTITUTE: 0,
            MODERATE_OFFER_PROBABILITY: 1,
            LOW_OFFER_PROBABILITY: 2
        };
        if (!(o1 === null || o1 === void 0 ? void 0 : o1.defaultLabel)) {
            return 1;
        }
        if (!(o2 === null || o2 === void 0 ? void 0 : o2.defaultLabel)) {
            return -1;
        }
        return priorityOrder[o1 === null || o1 === void 0 ? void 0 : o1.defaultLabel] - priorityOrder[o2 === null || o2 === void 0 ? void 0 : o2.defaultLabel];
    });
    return __spreadArray(__spreadArray([], __read(fixedOptions.filter(function (op) { return collegeIds.includes(op === null || op === void 0 ? void 0 : op.value); })), false), __read(fixedOptions.filter(function (op) { return !collegeIds.includes(op === null || op === void 0 ? void 0 : op.value); })), false);
};
export var disabledOption = function (option) {
    if (option === null || option === void 0 ? void 0 : option.count) {
        return (option === null || option === void 0 ? void 0 : option.count) === 0;
    }
    return true;
};
export var roundUpToNextNearestThousand = function (value) {
    return Math.ceil(value / 1000) * 1000;
};
export var roundDownToNextNearestThousand = function (value) {
    return Math.floor(value / 1000) * 1000;
};
export var showHighOfferChangesOptions = [{ label: 'High offer Institute', value: true }];
export var fieldToLabelMapping = {
    student: 'Student',
    twelfthGradingScheme: 'Twelfth Grading Scheme',
    twelfthGrade: 'Grade',
    ugGradingScheme: 'Grading Scheme',
    ugGrade: 'Grade',
    ugBacklogs: 'Backlogs',
    pgGradingScheme: 'Grading Scheme',
    pgGrade: 'Grade',
    englishExamType: 'Exam Type',
    englishTotalScore: 'Total Score',
    listening: 'Listening',
    reading: 'Reading',
    writing: 'Writing',
    speaking: 'Speaking',
    literacy: 'Literacy',
    conversation: 'Conversation',
    comprehension: 'Comprehension',
    production: 'Production',
    gmatQuant: 'Gmat Quant',
    englishExamGiven: 'English Exam Given',
    greGiven: 'Gre Given',
    gmatGiven: 'Gmat Given',
    greQuant: 'Gre Quant',
    greVerbal: 'Gre Verbal',
    greScore: 'Gre Score',
    gmatScore: 'Gmat Score',
    gmatVerbal: 'Gmat Verbal',
    yearsOfEducation: 'Years of Education',
    studentCountryId: 'Student Country',
    studentStateId: 'Student State',
    universityNaac: 'University NAAC',
    twelfthBoardCode: 'Board',
    twelfthGraduationYear: 'Graduation Year',
    ugUniversityCode: 'University',
    twelfthEnglishGrade: 'English Grade',
    englishExamStatus: 'English Exam Status',
    twelfthEnglishGradingScheme: 'Twelfth Grading Scheme'
};
export var OtherFiltersMapping = [
    { title: 'Without GMAT', key: 'withoutGmat', order: 1 },
    { title: 'Without GRE', key: 'withoutGre', order: 2 },
    { title: 'Without IELTS', key: 'withoutIelts', order: 3 },
    { title: 'TOEFL Accepted', key: 'toeflAllowed', order: 4 },
    { title: 'PTE Accepted', key: 'pteAllowed', order: 5 },
    { title: 'Duolingo Accepted', key: 'douLingoAllowed', order: 6 },
    { title: 'IELTS Accepted', key: 'ieltsAllowed', order: 7 },
    {
        title: '15 years of education',
        key: 'fifteenYearEducationAllowed',
        order: 8
    },
    {
        title: 'No Application Fee',
        key: 'noAppFee',
        order: 9
    },
    {
        title: 'Spousal Visa Preferred',
        key: 'spouseVisaPreferred',
        order: 10
    },
    {
        title: 'PGWP Given',
        key: 'pgwpGiven',
        order: 11
    },
    {
        title: 'Quick Offer',
        key: 'quickOffer',
        order: 12
    }
];
export var formKeyToFilterKey = {
    studentId: undefined,
    showOnlyPreferredInstitutes: undefined,
    cityIds: 'city_count',
    intake: 'intake_count',
    tuitionFeesMin: undefined,
    tuitionFeesMax: undefined,
    categoryIds: undefined,
    streamIds: undefined,
    courseDurationMin: 'duration_count',
    courseDurationMax: 'duration_count',
    englishExamType: undefined,
    englishExamScore: undefined,
    englishExamMinBand: undefined,
    ug_score_4: undefined,
    ug_score_10: undefined,
    ug_score_100: undefined,
    twelfth_score_10: undefined,
    twelfth_score_100: undefined,
    twelfthEnglishSubjectGrades: undefined,
    additionalExam: undefined,
    additionalExamScore: undefined,
    withoutGre: 'gre_count',
    withoutGmat: 'gmat_count',
    fifteenYearEducationAllowed: 'fifteen_year_education_allowed_count',
    moiAccepted: 'moi_accepted_count',
    noAppFee: 'no_app_fee_count',
    spouseVisaPreferred: 'spouse_visa_preferred_count',
    pgwpGiven: 'pgwp_given_count',
    quickOffer: 'quick_offer_count',
    countryIds: 'country_count',
    collegeIds: 'university_count',
    courseName: undefined,
    degreeIds: undefined,
    totalPerPage: undefined,
    pageIndex: undefined,
    sortBy: undefined,
    sortOrder: undefined,
    studentPreferenceToggleOn: undefined,
    cmsId: undefined,
    tags: undefined,
    categoryName: undefined,
    minimumShouldMatch: undefined,
    selectedFilter: undefined,
    stateId: 'state_count',
    showOnlyPartner: 'partner_count',
    backlog: undefined,
    withoutIelts: 'ielts_count',
    toeflAllowed: 'toefl_count',
    pteAllowed: 'pte_count',
    douLingoAllowed: 'duo_lingo_accepted',
    ieltsAllowed: 'ielts_accepted',
    showStemCourses: 'stem_courses_count',
    intakes: undefined,
    intakeStatus: undefined,
    selectedCategoryTab: undefined,
    workExperienceInMonths: undefined,
    academicBackground: undefined,
    sourceCountryId: undefined,
    degreeIdsV2: 'degree_count',
    universityRequest: undefined,
    isUniversityRequest: undefined,
    twelfth_score_4: undefined,
    specialisationIds: undefined,
    subStreamIds: undefined,
    courseIdsNotIn: undefined,
    live: undefined,
    partner: undefined,
    eligibilityDataVerified: undefined,
    countryGroupIds: undefined,
    universityUspAndOperation: undefined,
    universityUspOrOperation: undefined,
    gmatQuant: undefined,
    englishExamGiven: undefined,
    englishExamReading: undefined,
    englishExamWriting: undefined,
    englishExamListening: undefined,
    englishExamSpeaking: undefined,
    englishExamComprehension: undefined,
    englishExamConversation: undefined,
    englishExamProduction: undefined,
    englishExamLiteracy: undefined,
    greScore: undefined,
    greQuant: undefined,
    greVerbal: undefined,
    greGiven: undefined,
    gmatScore: undefined,
    gmatVerbal: undefined,
    gmatGiven: undefined,
    yearsOfEducation: undefined,
    courseIds: undefined,
    intakeMonths: undefined,
    courseNames: undefined,
    studentCountryId: undefined,
    studentStateId: undefined
};
export var aggregationKeyToFormKey = {
    toefl_count: 'toeflAllowed',
    pte_count: 'pteAllowed',
    duo_lingo_accepted: 'douLingoAllowed',
    ielts_accepted: 'ieltsAllowed'
};
export var englishExamsFromAggregation = [
    'pte_count',
    'duo_lingo_accepted',
    'toefl_count',
    'ielts_accepted'
];
export var noTabsCardBuckets = [
    'english_exam_type',
    'gmat_count',
    'gre_count',
    'student_selected',
    'pte_count',
    'duo_lingo_accepted',
    'toefl_count',
    'ielts_accepted'
];
export var tabCardBuckets = [
    'duolingo_total_score_less_than_equal_to',
    'european_country',
    'ielts_total_score_less_than_equal_to',
    'intake_count',
    'open_intake_count',
    'pte_total_score_less_than_equal_to',
    'toefl_total_score_less_than_equal_to',
    'twelfth_score_less_than_equal_to',
    'ug_score_less_than_equal_to'
];
export var englishExamLabels = {
    pte_count: 'PTE',
    duo_lingo_accepted: 'Duolingo',
    toefl_count: 'TOEFL',
    ielts_accepted: 'IELTS'
};
export var englishExamTabToScoreKeyMapper = {
    pte_count: 'pte_total_score_less_than_equal_to',
    duo_lingo_accepted: 'duolingo_total_score_less_than_equal_to',
    toefl_count: 'toefl_total_score_less_than_equal_to',
    ielts_accepted: 'ielts_total_score_less_than_equal_to'
};
export var bucketToEnglishExamEnumMapper = {
    ielts_total_score_less_than_equal_to: 'IELTS',
    duolingo_total_score_less_than_equal_to: 'DUOLINGO',
    toefl_total_score_less_than_equal_to: 'TOEFL',
    pte_total_score_less_than_equal_to: 'PTE'
};
export var gradeOptions = [
    {
        label: 'CGPA',
        value: 'CGPA'
    },
    {
        label: 'Percentage',
        value: 'PERCENTAGE'
    },
    {
        label: '0 to 4',
        value: 'ZERO_TO_FOUR'
    }
];
export var EnglishExamStatusEnum;
(function (EnglishExamStatusEnum) {
    EnglishExamStatusEnum["GIVEN"] = "GIVEN";
    EnglishExamStatusEnum["PLANNING_TO_GIVE"] = "PLANNING_TO_GIVE";
    EnglishExamStatusEnum["ENGLISH_EXAM_WAIVER"] = "ENGLISH_EXAM_WAIVER";
})(EnglishExamStatusEnum || (EnglishExamStatusEnum = {}));
export var EnglishExamStatusOptions = [
    {
        label: 'Given',
        value: EnglishExamStatusEnum.GIVEN
    },
    {
        label: 'Planning to Give',
        value: EnglishExamStatusEnum.PLANNING_TO_GIVE
    },
    {
        label: 'English Exam Waiver',
        value: EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER
    }
];
export var DateFormats;
(function (DateFormats) {
    DateFormats["DATE_MONTH_YEAR_HOUR_MINUTES_A"] = "do MMM Y , hh:mm a";
    DateFormats["DATE_MONTH_HOUR_MINUTES_A"] = "do MMM , hh:mm a";
    DateFormats["DATE_MONTH_YEAR"] = "do MMM Y";
    DateFormats["HOURS_MINUTES_A"] = "hh:mm a";
    DateFormats["MONTH_DATE_YEAR"] = "MMMM dd, Y ";
    DateFormats["DATE_FULL_MONTH_YEAR"] = "dd MMMM, Y ";
    DateFormats["DATE_MONTH_YEAR_WITH_SLASH"] = "dd/MM/yyyy";
})(DateFormats || (DateFormats = {}));
export var transformTimestampToReadableFormat = function (timeStamp, dateFormat) {
    if (!timeStamp || isFalsy(timeStamp))
        return;
    try {
        var parsedDate = new Date(timeStamp);
        if (!isValid(parsedDate))
            return;
        var formattedDate = format(parsedDate, dateFormat);
        return formattedDate;
    }
    catch (error) {
        console.log('Error in transforming time stamp', timeStamp, error);
        return undefined;
    }
};
//# sourceMappingURL=utils.js.map